import { getUnifiedInboxDistinguishedFolderId } from 'owa-folders-data-utils/lib/getUnifiedInboxDistinguishedFolderId';

// Checks if a folder name is for unified inbox
export function isUnifiedInboxFolder(folderName: string): boolean {
    // Instead of just replying on the prefix, also make sure that the folder name
    // part of the string is one of the supported folders in the unified inbox.
    return getUnifiedInboxDistinguishedFolderId(folderName) !== 'none';
}
